import React from "react";
import hostIntegration from "../integrations/host";

const useHostAudioMute = () => {
    const [muted, setMuted] = React.useState(false);

    React.useEffect(
        () => hostIntegration.onAudioMuteChanged(setMuted),
        []
    );

    return muted;
};

export default useHostAudioMute;
